import React, { useState, useRef, useEffect } from 'react';
import { Button } from 'components';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Spinner } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';

const AdminOtp = ({ email }) => {
  const [otp, setOTP] = useState(['', '', '', '']);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null); 
  const inputRefs = useRef([]);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (index, value) => {
    if (/^\d*$/.test(value)) {
      const newOTP = [...otp];
      newOTP[index] = value.substring(value.length - 1);
      setOTP(newOTP);
      if (value && index < 3) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace') {
      if (!otp[index] && index > 0) {
        inputRefs.current[index - 1].focus();
      }
    }
  };

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();

  const otpValue = otp.join('');

  if (otpValue.length < 4) {
    setError("Please enter complete 4-digit code.");
    return;
  }

  setLoading(true);
  setError(null);

    const payload = {
      code: otpValue,
      role: "admin",
      email: email
    };

    try {
      const response = await axios.post('https://production.washta.com/api/otp/verifiction', payload, {
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (response.data.status && response.data.code === 200) {
        const { accessToken, user } = response.data.data;
        localStorage.setItem('superAdmin', JSON.stringify(user));
        localStorage.setItem('accessTokenAdmin', accessToken);
        
        toast.success('Sign in successful!');
                setTimeout(() => {
            navigate('/super-admin-dashboard/sales');
        }, 1000);
      } else {
        setError(response.data.message || "Verification failed");
      }
    } catch (error) {
      console.error('Error during OTP verification:', error);
      setError(error.response?.data?.message || error.message);
      toast.error(error.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="otp-container fade-in">
      <h1 className='h1-heaing'>Enter your verification code</h1>
      <p className='paragraph-otp'> Enter 4 digit verification code sent to your registered Email Verification. </p>
      
     <form onSubmit={handleSubmit}>
  <div className="otp-input-container">
    {otp.map((digit, index) => (
      <input
        key={index}
        ref={el => inputRefs.current[index] = el}
        className="otp-input"
        type="text"
        inputMode="numeric"
        value={digit}
        maxLength={1}
        onChange={(e) => handleChange(index, e.target.value)}
        onKeyDown={(e) => handleKeyDown(index, e)}
      />
    ))}
  </div>

  {error && (
    <p className="error-paragrhp" style={{ color: "red", marginTop: "10px" }}>
      {error}
    </p>
  )}

  <Button
    type="submit"
    shape="round"
    className="min-w-[100%] sm:px-1"
    style={{
      fontSize: "16px",
      background: "white",
      color: "black",
      marginTop: "20px",
      fontFamily: "'General Sans', sans-serif",
    }}
    disabled={loading}
  >
    {loading ? (
      <Spinner
        animation="border"
        style={{ color: "#6b5fe4", width: "1.5em", height: "1.5em" }}
        size="sm"
      />
    ) : (
      "Submit"
    )}
  </Button>
</form>
      
      <ToastContainer />
    </div>
  );
};

export default AdminOtp;